import { useNavigate } from "react-router-dom";

const DevPage = () => {
  const navigate = useNavigate();
  return (
    <div className="p-10 text-3xl">
      Страница не найдена или находится в разработке, перейдите на{" "}
      <span className="text-[#3e41f1] cursor-pointer font-medium" onClick={() => navigate("/")}>
        главную
      </span>{" "}
      или вернитесь{" "}
      <span className="text-[#3e41f1] cursor-pointer font-medium" onClick={() => navigate(-1)}>
        назад
      </span>
    </div>
  );
};

export default DevPage;
